import React from "react";
import Tooltip from "@mui/material/Tooltip";
import TodayIcon from '@mui/icons-material/Today';
import DateRangeIcon from '@mui/icons-material/DateRange';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import EditCalendarIcon from '@mui/icons-material/EditCalendar';
import EventNoteIcon from '@mui/icons-material/EventNote';

interface ITimePeriodIconProps {
    timePeriod: string
}
const getTimePeriodIcon = (timePeriod: string) => {
    switch (timePeriod) {
        case 'Day':
            return <TodayIcon sx={{ ml: 3.5 }} />
        case 'Week':
            return <DateRangeIcon sx={{ ml: 3.5 }} />
        case 'Month':
            return <CalendarMonthIcon sx={{ ml: 3.5 }} />
        case 'Year':
            return <EventNoteIcon sx={{ ml: 3.5 }} />
        case 'Custom':
        case 'Manual':
            return <EditCalendarIcon sx={{ ml: 3.5 }} />
        default:
            return <></>
    }
}

export default function TimePeriodIcon({ timePeriod }: ITimePeriodIconProps) {

    return (
        <Tooltip title={timePeriod}>
            {getTimePeriodIcon(timePeriod)}
        </Tooltip>
    );
};
